module.exports = __webpack_public_path__ + "static/media/homepage_banner.49350b5e.png";